<script setup lang="ts">
import type { ProductDetail } from '~/types/api'

const props = defineProps<{
  hideSelector?: boolean
  products: ProductDetail[]
  selectedProduct: ProductDetail
  title: string
  dark?: boolean
}>()

const emit = defineEmits(['update:selected-product'])

const nonActiveProducts = computed(() => {
  return props.products.filter(
    (product) => product.nid !== props.selectedProduct.nid
  )
})
</script>

<template>
  <div class="flex overflow-visible">
    <UiSectionTitle :title="$t(title)" />
    <div
      v-if="!hideSelector"
      class="group relative z-30 ml-10 mt-2 h-max w-max whitespace-nowrap rounded-2xl bg-white p-2 text-sm"
      :class="[
        { '!bg-neutral-100': dark },
        {
          'cursor-pointer hover:rounded-b-none hover:bg-neutral-200':
            nonActiveProducts.length,
        },
        { 'hover:!bg-neutral-200': dark && nonActiveProducts.length },
      ]"
    >
      {{ props.selectedProduct?.title }}
      <Icon
        v-if="nonActiveProducts.length"
        size="12"
        class="ml-1 group-hover:hidden"
        name="bi:arrow-down"
      />
      <Icon
        v-if="nonActiveProducts.length"
        size="12"
        class="ml-1 !hidden group-hover:!inline-block"
        name="bi:arrow-up"
      />
      <div
        v-if="nonActiveProducts.length"
        class="absolute left-0 hidden w-full rounded-b-2xl bg-white px-2 pb-2 group-hover:block group-hover:bg-neutral-200"
      >
        <div
          v-for="product in nonActiveProducts"
          :key="product.nid"
          class="flex pb-2 first:pt-2 last:pb-0 hover:underline"
          @click="emit('update:selected-product', product)"
        >
          {{ product?.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
